import { BuilderElement } from '@builder.io/react';
import { ComponentProps } from 'react';
import { Block } from '../components/Block/Block';
import { Img } from '../components/Img/Img';

/**
 * This helps with autocomplete and to prevent typos.
 *  Note: This list is not exhaustive. Add Component names here as needed.
 */
type BuilderComponentName = 'img' | 'Block' | 'WistiaVideo' | 'BlockGridItem';

/**
 * BuilderElement factory. API inspired by React.createElement
 * @see createElement
 * @example
 *  builderElement('SomeComponent', {title: 'A title'})
 *  builderElement('SomeComponent', {title: 'A title'}, childElement)
 */
export function builderElement(
  name: BuilderComponentName,
  options?: { [key: string]: any },
  ...children: BuilderElement[]
): BuilderElement {
  return {
    '@type': '@builder.io/sdk:Element',
    component: {
      name,
      options,
    },
    children,
  };
}

/**
 * Img Factory
 * @param options
 */
export function imgElement(
  options: Partial<ComponentProps<typeof Img>> & { src: string },
) {
  return builderElement('img', {
    alt: 'This is alt text',
    ...options,
  });
}

/**
 * Block factory
 */
export function blockElement({
  mediaSrc,
  ...options
}: Partial<ComponentProps<typeof Block>> & { mediaSrc: string }) {
  const blockDefaults = {
    align: 'left',
    content: 'Default content',
    contentStyle: 'paragraph1',
    headingStyle: 'sectionHeader3',
    isPageWidth: true,
    textPlacement: 'left',
    mobileTextPlacement: 'bottom',
  };

  return builderElement(
    'Block',
    {
      ...blockDefaults,
      ...options,
    },
    imgElement({ src: mediaSrc }),
  );
}
